// RepoDetailDialog —— 仓库详情对话框(统一关闭约定,对齐 docs/ui_dialog)
// 由列表页点击行打开:Explore / Dashboard / AdminRepo 内联此对话框,
// 内嵌受控的 RepoDetailPage(经 props 传 owner/name),删除仓库后自动关闭。
import { useQuery } from '@tanstack/react-query';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogContent,
  Badge,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import { DatabaseRegular, GlobeRegular, LockClosedRegular } from '@fluentui/react-icons';
import { DialogCloseTitle } from '@/components/DialogCloseTitle';
import { RepoDetailPage } from '@/pages/RepoDetailPage';
import { reposApi } from '@/api/repos';

const useStyles = makeStyles({
  content: {
    padding: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  embed: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    paddingBottom: tokens.spacingVerticalL,
  },
});

export function RepoDetailDialog({
  owner,
  name,
  onClose,
}: {
  owner: string | null;
  name: string | null;
  onClose: () => void;
}) {
  const styles = useStyles();
  const open = !!owner && !!name;
  // 复用 RepoDetailPage 的 repo 缓存(queryKey 一致),取出可见性放到标题栏
  const { data: repo } = useQuery({
    queryKey: ['repo', owner, name],
    queryFn: () => reposApi.getRepo(owner!, name!),
    enabled: open,
    staleTime: 30_000,
  });
  const visibilityBadge =
    repo?.visibility === 'private' ? (
      <Badge appearance="tint" color="subtle" icon={<LockClosedRegular />}>
        private
      </Badge>
    ) : repo?.visibility === 'public' ? (
      <Badge appearance="tint" color="brand" icon={<GlobeRegular />}>
        public
      </Badge>
    ) : null;
  return (
    <Dialog open={open} onOpenChange={(_, d) => !d.open && onClose()} modalType="alert">
      <DialogSurface style={{ width: '95vw', maxWidth: 1280, height: '95vh' }}>
        <DialogBody style={{ height: '100%' }}>
          <DialogCloseTitle
            title={open ? `${owner}/${name}` : '仓库详情'}
            icon={<DatabaseRegular />}
            extra={visibilityBadge}
            onClose={onClose}
          />
          <DialogContent className={styles.content}>
            {open && (
              <div className={styles.embed}>
                <RepoDetailPage owner={owner ?? ''} name={name ?? ''} onDeleted={onClose} />
              </div>
            )}
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}